import { ProductType } from '@chegg/commerce-utils';

/**
 * Gets the item data object for a price quote item
 */
var getPriceQuoteItemData = function getPriceQuoteItemData(_ref, cspProduct) {
  var id = _ref.itemDetails.id,
    pricingLogId = _ref.pricingLogId;
  return [{
    catalogItemId: id,
    productType: ProductType.BUNDLE,
    pricingId: pricingLogId,
    catalogItemSource: 'NETSUITE',
    quantity: 1,
    annotation: cspProduct.eligibility.annotation,
    replace: true
  }];
};
export default getPriceQuoteItemData;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/getPriceQuoteItemData.js
// module id = 4353
// module chunks = 11